const pending = new Set();
const listeners = new Set();
let visible = false;
export function pendingRequestCount() { return pending.size; }
function publish() {
    const next = [...pending].some(request => request.slow);
    if (next === visible) return;
    visible = next;
    listeners.forEach(listener => listener(visible));
}
export function beginRequest() {
    const request = { slow: false };
    pending.add(request);
    window.dispatchEvent(new Event('pout-request-count'));
    const timer = setTimeout(() => { request.slow = true; publish(); }, 900);
    return () => { clearTimeout(timer); pending.delete(request); publish(); window.dispatchEvent(new Event('pout-request-count')); };
}
export function watchRequests(listener) {
    listeners.add(listener);
    listener(visible);
    return () => listeners.delete(listener);
}
